export default __webpack_public_path__ + "static/mp2-6029933640624c412dc481e99ad7f782.jpg";